@if (isRmbRmc) {
<p>{{ "OTHER_COVERAGE_STATICTEXT14" | globalTranslate }}</p>
}
<nh-form
  [individuals]="individuals"
  [formGroup]="getForm()"
  (validate)="onValidate($event)"
>
  <div [formGroup]="getControl('data')">
    <nh-field
      id="tfo_filerOutsideHoh"
      label="{{ 'TAX_FILER_STATIC_TEXT1' | globalTranslate }}"
      class="label-section"
    >
      <select
        [attr.aria-label]="'TAX_FILER_STATIC_TEXT1' | globalTranslate"
        nhTranslate
        name="filerOutsideHoh"
        formControlName="filerOutsideHoh"
        [items]="tableCodeValue('YESNO', 'data.filerOutsideHoh')"
      ></select>
    </nh-field>

    @if (isY('data.filerOutsideHoh')) {
    <div>
      <nh-alert type="warning" [isOpen]="hasIndividuals">
        <div class="row">
          <div class="col-auto icon">
            <img
              src="../../../../../../assets/images/Icons/⚛️ icons-warning-outline.svg"
              alt=""
            />
          </div>
          <div class="col message">
            <span class="visually-hidden"
              >{{ "Alert" | globalTranslate }}
            </span>
            <span>{{ "TAX_FILER_STATIC_TEXT4" | globalTranslate }}</span>
          </div>
        </div>
      </nh-alert>
      <nh-alert type="warning" [isOpen]="!hasIndividuals">
        <div class="row">
          <div class="col-auto icon">
            <img
              src="../../../../../../assets/images/Icons/⚛️ icons-warning-outline.svg"
              alt=""
            />
          </div>
          <div class="col message">
            <span class="visually-hidden"
              >{{ "Alert" | globalTranslate }}
            </span>
            <span
              [innerHTML]="'TAX_FILER_STATIC_TEXT3' | globalTranslate"
            ></span>
            <span
              ><b
                [innerHTML]="'TAX_FILER_STATIC_TEXT3_01' | globalTranslate"
              ></b
            ></span>
          </div>
        </div>
      </nh-alert>
      @if (hasIndividuals) {
      <div>
        <h1 class="section-header">
          {{ "TAX_FILER_STATIC_TEXT2" | globalTranslate }}
        </h1>
        <hr />
        <p class="static-text">
          {{ "TAX_FILER_STATIC_TEXT5" | globalTranslate }} <br />
          {{ "TAX_FILER_STATIC_TEXT6" | globalTranslate }}
        </p>
      </div>
      }
    </div>
    } @if (isY('data.filerOutsideHoh')) {
    <section>
      <div class="d-flex flex-column mt-2">
        <ng-container formArrayName="taxDependents">
          @for (taxDependent of taxDependents.controls; track taxDependent; let
          i = $index) {
          <section [formGroupName]="i" class="d-flex flex-column flex-lg-row">
            <div class="py-2 p-md-2 p-md-0 w-50 mt-4 checkbox">
              <label
                [for]="'tfo_taxDependent' + i"
                class="font-weight-normal ms-2 mt-2"
              >
                <input
                  id="{{ 'tfo_taxDependent' + i }}"
                  type="checkbox"
                  [disabled]="ischeckboxDisabled(i)"
                  name="taxDependent"
                  [checked]="isEnabled('taxFilerName', taxDependent)"
                  (click)="toggle(taxDependent)"
                />
                <span class="cr" tabindex="0"
                  ><i class="cr-icon fa fa-check" aria-hidden="true"></i
                ></span>
                {{ individuals[i] | fullname }}
              </label>
            </div>
            <div class="py-2 p-md-2 p-md-0 w-100">
              <nh-field
                id="{{ 'tfo_taxFilerName' + i }}"
                [isRow]="true"
                [mandatory]="isEnabled('taxFilerName', taxDependent)"
                [attr.aria-required]="isEnabled('taxFilerName', taxDependent)"
                label="{{ 'TAX_FILER_STATIC_TEXT7' | globalTranslate }}"
                class="label-section"
              >
                <input
                  [attr.aria-label]="'TAX_FILER_STATIC_TEXT7' | globalTranslate"
                  type="text"
                  name="taxFilerName"
                  maxlength="50"
                  class="form-control"
                  formControlName="taxFilerName"
                />
              </nh-field>
            </div>
            <div class="py-2 p-md-2 p-md-0 w-100">
              <nh-field
                id="{{ 'tfo_relationToTaxFiler' + i }}"
                [isRow]="true"
                [mandatory]="isEnabled('taxFilerName', taxDependent)"
                [attr.aria-required]="isEnabled('taxFilerName', taxDependent)"
                label="{{ 'TAX_FILER_STATIC_TEXT8' | globalTranslate }} {{
                  individuals[i] | fullname
                }}{{ 'TAX_FILER_STATIC_TEXT9' | globalTranslate }} {{
                  getValue('taxFilerName', taxDependent)
                }}?"
                class="label-section"
              >
                <select
                  nhTranslate
                  [attr.aria-label]="
                    ('TAX_FILER_STATIC_TEXT8' | globalTranslate) +
                    ' ' +
                    (individuals[i] | fullname) +
                    ' ' +
                    ('TAX_FILER_STATIC_TEXT9' | globalTranslate) +
                    ' ' +
                    getValue('taxFilerName', taxDependent)
                  "
                  name="relationToTaxFiler"
                  [items]="tableCodeValue('RELATIONTYPE', i)"
                  formControlName="relationToTaxFiler"
                ></select>
              </nh-field>
            </div>
          </section>
          }
        </ng-container>
      </div>
    </section>
    }
    <input
      id="tfo_hiddenInput"
      type="hidden"
      name="hiddenInput"
      formControlName="hiddenInput"
    />
  </div>
</nh-form>